<div
    class="flex size-full flex-col items-center justify-end px-84 pb-64"
    [ngStyle]="{ 'background-color': '#' + slide().colorBegin }"
    [style.--carousel-focus-ring]="focusRingColor()"
>
    <div
        class="flex grow items-center"
        [ngClass]="{
            'flex-col': slide().orientation_WebApp === 'column',
        }"
    >
        <div class="flex-1 text-center">
            <img alt="" class="max-h-4/5 max-w-4/5" [src]="slide().urlImage" />
        </div>
        <div
            class="flex flex-1"
            [ngClass]="{
                'flex-col gap-y-60': slide().orientation_WebApp !== 'column',
            }"
        >
            <h2
                class="typo-t2"
                [innerHTML]="slide().title"
                [ngStyle]="{
                    color: '#' + slide().titleColor,
                }"
            ></h2>
            <span
                class="font-400"
                [innerHTML]="slide().description"
                [ngStyle]="{
                    'font-size': config().descriptionFontSize_WebApp + 'px',
                    'line-height': '130%',
                    color: '#' + slide().descriptionColor,
                }"
            ></span>
            @if (isLast()) {
                <button
                    #doneButton
                    class="focus-visible:outline-(--carousel-focus-ring)"
                    interacta-button
                    type="button"
                    [attr.cdkFocusRegionStart]="active() ? '' : null"
                    [label]="config().nameDoneBtn"
                    [style]="'filled'"
                    (click)="closeCarousel.emit()"
                ></button>
            }
        </div>
    </div>
    <div class="flex items-center gap-x-100">
        @if (!isLast()) {
            <button
                class="focus-visible:outline-(--carousel-focus-ring)"
                interacta-button
                type="button"
                [attr.cdkFocusRegionStart]="active() ? '' : null"
                [label]="config().nameSkipBtn"
                [ngStyle]="{ color: '#' + skipColor() }"
                (click)="closeCarousel.emit()"
            ></button>
        }
        <div class="flex items-center gap-x-24">
            @for (item of totalItems() | array; track $index) {
                <button
                    #dot
                    class="size-12 rounded-full border-2 border-black bg-surface-100 focus-visible:outline-offset-2 focus-visible:outline-(--carousel-focus-ring)"
                    type="button"
                    [attr.aria-current]="index() === $index ? 'true' : null"
                    [attr.aria-label]="
                        'BUTTON.ACCESSIBILITY.GO_TO_STEP'
                            | translate: { step: $index + 1 }
                    "
                    [attr.cdkFocusRegionEnd]="
                        active() && isLast() && $last ? '' : null
                    "
                    [ngClass]="{
                        'size-14 bg-surface-A-reverse': index() === $index,
                    }"
                    [ngStyle]="{
                        background:
                            index() === $index
                                ? '#' + config().colorDot
                                : 'rgba(0, 0, 0, 0.2)',
                    }"
                    (click)="nextStep.emit({ index: $index, control: 'dot' })"
                ></button>
            }
        </div>
        @if (!isLast()) {
            <button
                #nextButton
                class="focus-visible:outline-(--carousel-focus-ring)"
                interacta-button
                type="button"
                [attr.cdkFocusRegionEnd]="active() ? '' : null"
                [label]="config().nameNextBtn"
                [ngStyle]="{ color: '#' + nextColor() }"
                (click)="nextStep.emit({ index: index() + 1, control: 'next' })"
            ></button>
        }
    </div>
</div>
